const constantsValidation = {
    SETTING_DEVICES: ['chrome', 'edge', 'edge-chromium', 'safari', 'ios', 'crios'],
    SETTING_OS: ['Windows 10', 'Chrome OS', 'Android OS', 'iOS', 'iPad', 'Mac OS'],
    VALID_TIME:{
        START: 6,
        END: 24,
    },
    VALID_HALF_WIDTH: /^[[\]a-zA-Z0-9.@!#$%&'*+\\=?^_`{|}~-]+$/,
    VALID_HIRAGANA: /^[0-9０-９ー\u3040-\u309f]+$/,
    FORM:{
        MAX_LENGTH_TEXT: 255,
        MAX_LENGTH_LOGIN: 254,
    },
    MAX_LENGTH_DISH_NAME: 20,
    MAXIMUM_VALUE_SEARCH_MATERIAL : 10,
    CHOOSE_DISH: {
        MAXIMUM_NUMBER_OF_DISHES_IN_MEAL: 15,
        MAXIMUM_NUMBER_OF_CUTLERY_IN_A_MEAL: 10
    },
    MAXIMUM_VALUE_FOR_SNACK: 6,
    NAME_REGISTRATION : {
        SURNAME : 20,
        NAME : 20
    },
    ADD_DISH_INFORMATION: {
        MIN_NUM_PEOPLE: 1,
        MAX_NUM_PEOPLE: 9,
        MAX_QUANTITY_PER_PEOPLE: 9999,
        MIN_QUANTITY_PER_PEOPLE: 0.1,
    },
    SIZE_1MB: 1048576,
};

export default constantsValidation;